<div class="form form--ssn form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>

  <div class="form__field">
    <basic-text-input
      [propertyName]="questionItem.prop"
      [placeholder]="questionItem.placeholder"
      [formatterType]="fieldType"
      [parserType]="fieldType.toUpperCase()"
      [inputType]="'text'"
    ></basic-text-input>
  </div>
</div>
